import React, { useEffect } from 'react';
import { useParams, Link, Navigate } from 'react-router-dom';
import Header from '../components/Header';
import Footer from '../components/Footer';

import imgCollectionLinho from '../components/btnLinho.jpg';
import imgCharges from '../components/btnRecargas.jpg';
import imgCollectionLotus from '../components/Lotus1.jpg';


const Collection = () => {
  const { collectionName } = useParams();

  // Scroll to top when component mounts
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }, []);

  // For Pure collection - multiproduct page
  if (collectionName === 'pure') {
    const products = [
      {
        name: 'Linho',
        path: '/product/linho',
        description: 'Elegância natural que evoca a suavidade e pureza do linho. Uma experiência sensorial refinada.',
        image: imgCollectionLinho,
        price: '€30'
      },
      {
        name: 'Recargas',
        path: '/product/charcoal',
        description: 'Sofisticação contemporânea com toques terrosos. Elegância moderna e conexão natural.',
        image: imgCharges,
        price: '€35'
      },
      {
        name: 'Lotus',
        path: '/product/lotus',
        description: 'Colecção 2025.',
        image: imgCollectionLotus,
        price: '€0'
      }
    ];

    return (
      <div className="min-h-screen bg-pure_fundo">
        <Header />
        
        {/* Hero Section */}
        <section className="relative py-24 overflow-hidden">

          {/* 
          <div className="absolute inset-0">
            <img 
              src="https://images.unsplash.com/photo-1646647586503-8635c616a83e"
              alt="Pure collection background"
              className="w-full h-full object-cover opacity-30"
            />
            <div className="absolute inset-0 bg-gradient-to-br from-[#FEFEFE] to-[#F5F5F5] opacity-80"></div>
          </div>
          */}
          
          <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
            <h1 className="text-5xl md:text-7xl text-pure_titulo font-lora mb-6">
              Pure
            </h1>
            <p className="text-xl md:text-2xl max-w-4xl mx-auto leading-relaxed text-pure_btn1_txt font-montserrat">
              Minimalismo e sofisticação na sua forma mais pura
            </p>
          </div>
        </section>

        {/* Products Selection */}
        <section className="py-24">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">

            <div className="grid grid-cols-1 lg:grid-cols-2 gap-16">
              {products.map((product) => (
                <div key={product.name} className="group">
                  <Link 
                    to={product.path}
                    className="block relative overflow-hidden rounded-3xl shadow-2xl hover:shadow-3xl transition-all duration-500 hover:scale-105"
                  >
                    {/* Product Image */}
                    <div className="aspect-w-16 aspect-h-12 relative">
                      <img 
                        src={product.image} 
                        alt={`${product.name} product`}
                        className="w-full h-96 object-cover"
                      />
                      <div className={`absolute inset-0 bg-pure_fundo opacity-70`}></div>
                      
                      {/* Overlay Content */}
                      <div className="absolute inset-0 flex flex-col justify-center items-center text-center p-8">
                        <h3 className="text-4xl md:text-5xl font-bold text-pure_titulo mb-6" style={{ fontFamily: 'Dream Avenue, serif' }}>
                          {product.name}
                        </h3>
                      </div>
                    </div>
                  </Link>
                </div>
              ))}
            </div>
          </div>
        </section>

        <Footer />
      </div>
    );
  }

  // For other collections - redirect to single product pages
  if (collectionName === 'classico') {
    return <Navigate to="/product/classico" replace />;
  }
  
  if (collectionName === 'alquimia') {
    return <Navigate to="/product/alquimia" replace />;
  }

  // Default fallback
  return <Navigate to="/candles" replace />;
};

export default Collection;